module.exports = "/static/Images/es/Satisfied.png";